import c from "classnames";
import { PropsWithChildren, Ref } from "react";

import classes from "./Box.module.css";

type Props = PropsWithChildren<{
  gap?: number;
  direction?: "row" | "column";
  align?: "start" | "center" | "end";
  justify?: "flex-start" | "center" | "flex-end" | "space-between";
  wrap?: boolean;
  padding?: string;
  stretch?: boolean;
  fullStretch?: boolean;
  fullWidth?: boolean;
  grow?: number;
  shrink?: number;
  ref?: Ref<HTMLDivElement>;
}>;

export const Box = ({
  gap = 0,
  direction = "row",
  align = "start",
  justify = "flex-start",
  wrap,
  padding = "0",
  fullWidth = false,
  stretch = false,
  fullStretch = false,
  grow,
  shrink,
  ...rest
}: Props) => {
  const stretchProps = stretch
    ? {
        width: stretch && direction === "row" ? "100%" : undefined,
        height: stretch && direction === "column" ? "100%" : undefined,
      }
    : {};

  if (fullStretch) {
    stretchProps.width = "100%";
    stretchProps.height = "100%";
  }

  if (fullWidth) {
    stretchProps.width = "100%";
  }

  const styles = {
    gap,
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    padding,
    flexGrow: grow,
    flexShrink: shrink,
    ...stretchProps,
  };

  return (
    <div
      className={c(classes.box, wrap && classes.wrap)}
      style={styles}
      {...rest}
    />
  );
};
